var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c(
        "div",
        {
          staticClass: "vks-settings-backdrop",
          attrs: { role: "presentation" },
          on: { click: _vm.onBackdropClick },
        },
        [
          _c(
            "div",
            {
              staticClass: "vks-settings-modal",
              attrs: {
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "vks-settings-title",
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c("header", { staticClass: "vks-settings-head" }, [
                _c("h2", { attrs: { id: "vks-settings-title" } }, [
                  _vm._v("Settings"),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "vks-settings-close",
                    attrs: { type: "button", "aria-label": "Close settings" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("close")
                      },
                    },
                  },
                  [_vm._v(" × ")]
                ),
              ]),
              _c(
                "div",
                {
                  staticClass: "vks-ui-tabs",
                  attrs: { role: "tablist", "aria-label": "Settings panels" },
                },
                _vm._l(_vm.tabs, function (tab) {
                  return _c(
                    "button",
                    {
                      key: tab.id,
                      staticClass: "vks-ui-tab",
                      class: { "is-active": _vm.activeTab === tab.id },
                      attrs: {
                        id: `vks-settings-tab-${tab.id}`,
                        type: "button",
                        role: "tab",
                        "aria-selected":
                          _vm.activeTab === tab.id ? "true" : "false",
                        "aria-controls": `vks-settings-panel-${tab.id}`,
                      },
                      on: {
                        click: function ($event) {
                          _vm.activeTab = tab.id
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(tab.label) + " ")]
                  )
                }),
                0
              ),
              _c("div", { staticClass: "vks-settings-body" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeTab === "settings",
                        expression: "activeTab === 'settings'",
                      },
                    ],
                    staticClass: "vks-settings-panel",
                    attrs: {
                      id: "vks-settings-panel-settings",
                      role: "tabpanel",
                      "aria-labelledby": "vks-settings-tab-settings",
                    },
                  },
                  [
                    _c("section", { staticClass: "vks-settings-section" }, [
                      _c("h3", { staticClass: "vks-ui-section-title" }, [
                        _vm._v("Project"),
                      ]),
                      _vm._m(0),
                      _c(
                        "label",
                        {
                          staticClass: "vks-settings-project-label",
                          attrs: { for: "vks-settings-project" },
                        },
                        [
                          _vm._v(" Active project "),
                          _c(
                            "select",
                            {
                              staticClass: "vks-settings-project-select",
                              attrs: { id: "vks-settings-project" },
                              domProps: { value: _vm.projectId },
                              on: { change: _vm.onProjectChange },
                            },
                            _vm._l(_vm.projectOptions, function (project) {
                              return _c(
                                "option",
                                {
                                  key: project.id || "default",
                                  domProps: { value: project.id },
                                },
                                [_vm._v(" " + _vm._s(project.label) + " ")]
                              )
                            }),
                            0
                          ),
                        ]
                      ),
                    ]),
                    _c("section", { staticClass: "vks-settings-section" }, [
                      _c("h3", { staticClass: "vks-ui-section-title" }, [
                        _vm._v("Show / Hide sections"),
                      ]),
                      _c("p", { staticClass: "vks-ui-hint" }, [
                        _vm._v(
                          " Uncheck a section to hide it on the workspace and from the section drawer tabs. Associations and nested tracks stay in sync with these checkboxes. "
                        ),
                      ]),
                      _c(
                        "ul",
                        { staticClass: "vks-settings-section-list" },
                        _vm._l(_vm.sections, function (section) {
                          return _c(
                            "li",
                            {
                              key: section.id,
                              staticClass: "vks-settings-section-item",
                            },
                            [
                              _c("label", [
                                _c("input", {
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: _vm.isVisible(section.id),
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.onToggleSection(
                                        section.id,
                                        $event
                                      )
                                    },
                                  },
                                }),
                                _c(
                                  "span",
                                  { staticClass: "vks-settings-section-label" },
                                  [_vm._v(" " + _vm._s(section.label) + " ")]
                                ),
                              ]),
                              section.description
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "vks-settings-section-desc",
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(section.description) + " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        }),
                        0
                      ),
                    ]),
                    _c("section", { staticClass: "vks-settings-section" }, [
                      _c("h3", { staticClass: "vks-ui-section-title" }, [
                        _vm._v("Region zoom"),
                      ]),
                      _c("p", { staticClass: "vks-ui-hint" }, [
                        _vm._v(
                          " Association data is downsampled on initial load to keep memory and rendering lightweight. When enabled, zooming in to 100% refetches full association data for the zoomed-in viewing region. "
                        ),
                      ]),
                      _c(
                        "label",
                        { staticClass: "vks-settings-suggest-label" },
                        [
                          _c("input", {
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: _vm.refetchAssociationsOnZoom,
                            },
                            on: {
                              change: _vm.onRefetchAssociationsOnZoomChange,
                            },
                          }),
                          _c("span", [
                            _vm._v(
                              "Refetch association data for zoomed-in region"
                            ),
                          ]),
                        ]
                      ),
                    ]),
                    _c("section", { staticClass: "vks-settings-section" }, [
                      _c("h3", { staticClass: "vks-ui-section-title" }, [
                        _vm._v("Suggest Actions"),
                      ]),
                      _c("p", { staticClass: "vks-ui-hint" }, [
                        _vm._v(
                          " When enabled, the Actions panel opens automatically after workspace actions that have a suggested next step. When disabled, the panel stays closed until you open it. "
                        ),
                      ]),
                      _c(
                        "label",
                        { staticClass: "vks-settings-suggest-label" },
                        [
                          _c("input", {
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: _vm.suggestActionsAfterUserAction,
                            },
                            on: { change: _vm.onSuggestActionsChange },
                          }),
                          _c("span", [
                            _vm._v(
                              "Suggest available actions after user action"
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeTab === "apis",
                        expression: "activeTab === 'apis'",
                      },
                    ],
                    staticClass: "vks-settings-panel",
                    attrs: {
                      id: "vks-settings-panel-apis",
                      role: "tabpanel",
                      "aria-labelledby": "vks-settings-tab-apis",
                    },
                  },
                  [
                    _c(
                      "p",
                      { staticClass: "vks-ui-hint" },
                      [
                        _vm._v(" Endpoints used to load GP2 Browser data. "),
                        _vm.bioIndexHost
                          ? [
                              _vm._v(" BioIndex host: "),
                              _c("code", { staticClass: "vks-settings-host" }, [
                                _vm._v(_vm._s(_vm.bioIndexHost)),
                              ]),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c(
                      "ul",
                      { staticClass: "vks-settings-api-list" },
                      _vm._l(_vm.apis, function (api) {
                        return _c(
                          "li",
                          { key: api.id, staticClass: "vks-settings-api-item" },
                          [
                            _c(
                              "div",
                              { staticClass: "vks-settings-api-head" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "vks-settings-api-name" },
                                  [_vm._v(_vm._s(api.name))]
                                ),
                                _c(
                                  "span",
                                  { staticClass: "vks-settings-api-service" },
                                  [_vm._v(_vm._s(api.service))]
                                ),
                              ]
                            ),
                            _c("p", { staticClass: "vks-settings-api-path" }, [
                              _vm._v(_vm._s(api.url || api.path)),
                            ]),
                            _c("p", { staticClass: "vks-settings-api-query" }, [
                              _c(
                                "span",
                                { staticClass: "vks-settings-api-k" },
                                [_vm._v("Query")]
                              ),
                              _vm._v(" " + _vm._s(api.query) + " "),
                            ]),
                            _c(
                              "p",
                              { staticClass: "vks-settings-api-purpose" },
                              [_vm._v(_vm._s(api.purpose))]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeTab === "information",
                        expression: "activeTab === 'information'",
                      },
                    ],
                    staticClass: "vks-settings-panel",
                    attrs: {
                      id: "vks-settings-panel-information",
                      role: "tabpanel",
                      "aria-labelledby": "vks-settings-tab-information",
                    },
                  },
                  [
                    _c(
                      "dl",
                      { staticClass: "vks-settings-info-list" },
                      _vm._l(_vm.informationRows, function (row) {
                        return _c(
                          "div",
                          {
                            key: row.label,
                            staticClass: "vks-settings-info-row",
                          },
                          [
                            _c("dt", [_vm._v(_vm._s(row.label))]),
                            _c("dd", [
                              _c(
                                "span",
                                { staticClass: "vks-settings-info-value" },
                                [_vm._v(_vm._s(row.value))]
                              ),
                              row.detail
                                ? _c(
                                    "span",
                                    { staticClass: "vks-settings-info-detail" },
                                    [_vm._v(" " + _vm._s(row.detail) + " ")]
                                  )
                                : _vm._e(),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                ),
              ]),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "vks-ui-hint" }, [
      _vm._v(
        " Project selects the BioIndex data source and the available phenotypes and ancestries. It can also be set with the "
      ),
      _c("code", [_vm._v("project")]),
      _vm._v(" URL parameter (for example "),
      _c("code", [_vm._v("&project=giant")]),
      _vm._v("). Changing project clears the current workspace search. "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }